module.exports = __webpack_public_path__ + "static/media/Android_Studio_Icon.f6251e02.png";